import React from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { ERROR_EMUNS, LOADING_EMUNS } from "../constant";
import { Link } from "react-router-dom";
import { Icon } from "ccui-framework";
import * as a from "../action";

const UploadSpreadSheetUnsupportedFile = () => {
  const dispatch = useDispatch();
  const loadingState = useSelector((state) => state.ssUploader.loading.state);
  const errorType = useSelector((state) => state.ssUploader.error.type);

  const Wrapper = styled.div`
    display: flex;
    justify-content: center;
  `;

  const Container = styled.div`
    text-align: center;
    margin: 30px 0 0 0;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebcccc;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 0.25rem;
  `;

  const CloseContainer = styled.div`
    justify-content: end;
    align-items: end;
    display: flex;
  `;

  const Strong = styled.strong`
    font-weight: 700;
  `;

  if (
    loadingState === LOADING_EMUNS.ERROR &&
    errorType === ERROR_EMUNS.INVALID_FILE
  ) {
    return (
      <Wrapper>
        <Container>
          <CloseContainer
            onClick={() => {
              dispatch(a.setLoadingState(LOADING_EMUNS.DEFAULT));
              dispatch(a.setErrorType(ERROR_EMUNS.DEFAULT));
            }}
          >
            <Icon name="fa-times" />
          </CloseContainer>
          <Strong>Oops!</Strong> <br />
          <div>
            We had trouble processing that file due to a formatting issue.
          </div>
          <Link to="/spreadsheet-instructions" target="_blank">
            Click here to see the required format.
          </Link>
        </Container>
      </Wrapper>
    );
  }

  return null;
};

export { UploadSpreadSheetUnsupportedFile };
